export default "__VITE_ASSET__CkexaLZI__"